import { render, staticRenderFns } from "./addMemberTagType.vue?vue&type=template&id=aa9dbff0"
import script from "./addMemberTagType.vue?vue&type=script&lang=js"
export * from "./addMemberTagType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports